import Api from '../Api';

import { url } from './config';
import { ServiceAttribute } from './types';

const api = new Api<ServiceAttribute>(url);

export default api;
